import * as React from 'react'
import { useReducer, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import GridContainer from '../../../../grid/GridContainer'
import GridItem from '../../../../grid/GridItem'
import CustomInput from '../../../../input/CustomInput'
import Button from '../../../../button/RegularButton'
import { timeout } from '../../../../../App'
import Snackbar from '../../../../snackbar/Snackbar'
import { AddAlert } from '@material-ui/icons'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import { CountryDropdown } from 'react-country-region-selector'
import MenuItem from '@material-ui/core/MenuItem'
import styles from '../../../../../assets/jss/dorm-app/customSelectStyle.js'
import CustomDateInput from '../../../../input/CustomDateInput'
import { initialNotificationState } from '../../../../utils/state/ApplicationState'
import UniversitySelect from './UniversitySelect'
import { stringifyDates } from '../../../../utils/DateUtils'
import { getApiUrl } from '../../../../../api/api'

const useStyles = makeStyles(styles)

function tenantReducer(state, action) {
  switch (action.type) {
    case 'field':
      return {
        ...state,
        [action.field]: action.value,
      }

    case 'success':
      return {
        ...initialTenantState,
        success: true,
      }

    case 'error':
      return {
        ...state,
        success: false,
      }

    default:
      break
  }
  return state
}

const initialTenantState = {
  success: false,
  name: '',
  surname: '',
  email: '',
  telNumber: '',
  birthday: null,
  gender: '',
  nationality: '',
  university: '',
  studyField: '',
  room: '',
  movedIn: null,
  deposit: '',
  note: '',
}

export default function CreateTenant() {
  const classes = useStyles()

  const [state, dispatch] = useReducer(tenantReducer, initialTenantState)

  const [notification, setNotification] = useState(initialNotificationState)

  function validateInput() {
    if (state.nationality.length === 0) {
      setNotification({
        open: true,
        message: 'Bitte Staatsangehörigkeit angeben.',
        color: 'danger',
      })
      return false
    }
    return true
  }

  const submitForm = (e) => {
    e.preventDefault()

    if (validateInput()) {
      getApiUrl()
        .post(`/admin/tenants`, stringifyDates(state))
        .then(function() {
          dispatch({ type: 'success' })
          setNotification({
            open: true,
            message: 'Bewohner hinzugefügt',
            color: 'success',
          })
        })
        .catch(function(error) {
          dispatch({ type: 'error' })
          setNotification({
            open: true,
            message: error.response.data.message,
            color: 'danger',
          })
        })
        .finally(
          setTimeout(function() {
            setNotification(initialNotificationState)
          }, timeout),
        )
    }
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Vorname"
              id="name"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.name,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'name',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Nachname"
              id="surname"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.surname,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'surname',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Email"
              id="email"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.email,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'email',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={2}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel htmlFor="gender" className={classes.selectLabel}>
                Geschlecht
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                value={state.gender}
                onChange={(e) =>
                  dispatch({
                    type: 'field',
                    field: 'gender',
                    value: e.currentTarget.getAttribute('data-value'),
                  })
                }
                inputProps={{
                  name: 'gender',
                  id: 'gender',
                }}>
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                  value="MALE">
                  Männlich
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                  value="FEMALE">
                  Weiblich
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                  value="DIVERSE">
                  Divers
                </MenuItem>
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <CountryDropdown
              value={state.nationality}
              id="nationality"
              defaultOptionLabel={'Staatsangehörigkeit'}
              priorityOptions={['DE', 'IT', 'AT', 'ES']}
              onChange={(val) =>
                dispatch({
                  type: 'field',
                  field: 'nationality',
                  value: val,
                })
              }
              classes={`MuiSelect-root MuiInputBase-input`}
              style={{
                width: '100%',
                margin: '47px 0 0 0',
                position: 'relative',
                verticalAlign: 'unset',
                font: 'inherit',
                fontWeight: '400',
                cursor: 'pointer',
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <CustomDateInput
              labelText="Geburt"
              id="birthday"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.birthday,
                onChange: (date) => {
                  dispatch({
                    type: 'field',
                    field: 'birthday',
                    value: date,
                  })
                },
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Telefonnummer"
              id="telNumber"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.telNumber,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'telNumber',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <CustomDateInput
              labelText="Einzug"
              id="movedIn"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.movedIn,
                onChange: (date) => {
                  dispatch({
                    type: 'field',
                    field: 'movedIn',
                    value: date,
                  })
                },
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={2}>
            <CustomInput
              labelText="Zimmer"
              id="room"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.room,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'room',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={2}>
            <CustomInput
              labelText="Kaution"
              id="deposit"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.deposit,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'deposit',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={2}>
            <UniversitySelect state={state} dispatch={dispatch}/>
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Studienfach"
              id="studyField"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.studyField,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'studyField',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <CustomInput
              labelText="Notiz der Verwaltung"
              id="note"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.note,
                type: 'text',
                multiline: true,
                rows: 5,
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'note',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
        </GridContainer>
        <br/>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <Button
              color="primary"
              onClick={(e) => {
                submitForm(e)
              }}>
              Bewohner hinzufügen
            </Button>
          </GridItem>
        </GridContainer>
        <Snackbar
          place="br"
          color={notification.color}
          icon={AddAlert}
          message={notification.message}
          open={notification.open}
          closeNotification={() =>
            setNotification({
              open: false,
              message: '',
              color: '',
            })
          }
          close
        />
      </GridItem>
    </GridContainer>
  )
}
